import PageHeader from "@/components/PageHeader";
import { usePageMeta } from "@/hooks/usePageMeta";

// Renders provisional legal content with a clear "provisional" banner and
// optional per-section completion flags. Wording is intentionally easy to
// replace before launch.
export default function LegalLayout({ eyebrow, title, intro, updated, sections, metaDescription, provisional = false }) {
  usePageMeta(`${title} | Amanah Promotions`, metaDescription || intro);

  return (
    <>
      <PageHeader eyebrow={eyebrow} title={title} intro={intro} />
      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-6 py-16 sm:px-10 sm:py-20 lg:px-16">
          {provisional && (
            <div className="mb-10 border-l-2 border-brand-green bg-cream p-5 text-sm leading-relaxed text-slate-body">
              <strong className="font-semibold text-navy">Provisional wording.</strong> This content
              has been prepared for launch and may be replaced before final publication.
            </div>
          )}

          {updated && (
            <p className="mb-10 text-sm text-slate-muted">Last updated: {updated}</p>
          )}

          <div className="space-y-12">
            {sections.map((s, i) => (
              <div key={i}>
                {s.heading && (
                  <h2 className="font-display text-xl font-medium text-navy sm:text-2xl">
                    {s.heading}
                  </h2>
                )}
                {s.paragraphs?.map((p, j) => (
                  <p key={j} className="mt-4 text-base leading-relaxed text-slate-body">
                    {p}
                  </p>
                ))}
                {s.list && (
                  <ul className="mt-4 space-y-2">
                    {s.list.map((item, k) => (
                      <li key={k} className="flex items-start gap-3 text-base leading-relaxed text-slate-body">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-brand-green" aria-hidden="true" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                )}
                {s.note && (
                  <p className="mt-4 border border-line bg-cream px-4 py-3 text-sm text-slate-body">
                    <span className="font-medium text-brand-greenDeep">[To be confirmed]</span>{" "}
                    {s.note}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
